/* =============================================================================
 * M.M.LaFleur — mobile drawer accordions.
 *
 * SYMPTOM: on mobile the burger opens the drawer, but tapping Shop or Stores
 * never reveals their links. The rows render with a chevron-down, so the
 * panels exist and are populated — they simply never open.
 *
 * DIAGNOSIS: opening the drawer is idempotent (`setDrawer(true)` twice is
 * still open) and works. The accordion is a *toggle*, and a toggle run twice
 * lands back where it started. That asymmetry — idempotent actions fine,
 * toggles dead — is the signature of the same click being handled more than
 * once: the panel opens and closes again inside a single tap.
 *
 * mm-editorial.js handles `.mm-drawer-toggle` through a delegated listener on
 * document. Anything else that binds the same selector cancels it out, and the
 * drawer is moved to <body> at runtime by mm-nav-drawer.js, so "how many
 * listeners are live" is not something the markup can guarantee on its own.
 *
 * FIX: own the interaction here, on the CAPTURE phase. Capture runs before
 * every bubble listener regardless of script order, so the click is settled
 * before anything else sees it. The state is then SET once, from the row's own
 * aria-expanded, rather than toggled N times.
 *
 * UPDATED: this originally called stopPropagation, which is not sufficient.
 * Platter re-injects the footer's scripts around a Barba container swap, so
 * after the first soft navigation this file executes again and binds a SECOND
 * capture listener to document. stopPropagation stops the event reaching other
 * NODES but not other listeners on the SAME node in the SAME phase, so that
 * duplicate still fired and the drawer rows went dead exactly the way the PDP
 * accordions did. The load guard prevents the duplicate registration, and
 * stopImmediatePropagation makes a duplicate harmless if one ever appears.
 *
 * Panels are found via the row's <li> rather than nextElementSibling, so the
 * markup can gain a wrapper later without silently breaking this again.
 * ========================================================================== */

(function () {
  "use strict";

  if (window.__mmDrawerAccordionBound) return;
  window.__mmDrawerAccordionBound = true;

  document.addEventListener(
    "click",
    function (event) {
      var target = event.target;
      if (!target || !target.closest) return;

      var row = target.closest(".mm-drawer-toggle");
      if (!row) return;

      /* Top-level items with no sub-links render as <a> — they are
         destinations, not accordions. Let those navigate untouched so
         mm_header.liquid's close-on-navigate handler still fires. */
      if (row.tagName === "A") return;

      var item = row.closest("li");
      var panel = item ? item.querySelector(".mm-drawer-panel") : row.nextElementSibling;
      if (!panel) return;

      event.preventDefault();
      event.stopImmediatePropagation();

      var isOpen = row.getAttribute("aria-expanded") === "true";
      var next = isOpen ? "false" : "true";

      row.setAttribute("aria-expanded", next);
      panel.setAttribute("data-open", next);

      /* Accordion behaviour: opening one closes the others, so the drawer
         never becomes a single long scroll on a phone. Closing a row leaves
         the rest alone. */
      if (!isOpen && item && item.parentElement) {
        var siblings = item.parentElement.children;
        for (var i = 0; i < siblings.length; i++) {
          if (siblings[i] === item) continue;
          var otherRow = siblings[i].querySelector(".mm-drawer-toggle");
          var otherPanel = siblings[i].querySelector(".mm-drawer-panel");
          if (otherRow && otherRow.tagName !== "A") otherRow.setAttribute("aria-expanded", "false");
          if (otherPanel) otherPanel.setAttribute("data-open", "false");
        }
      }
    },
    true
  );
}());
